if($('.social-icon-list').length){
    $('.navigation-buttons').prepend($('.social-icon-list>a').clone())
}